const baseUrl: string = process.env.REACT_APP_API_URL || '';

class Footer {
    private uri: string;

    constructor(uri: string) {
        this.uri = uri;
    }

    public read = () => ({
        baseUrl,
        method: 'get',
        uri: this.uri,
    });

    public post = (params: any) => ({
        baseUrl,
        method: 'patch',
        params,
        uri: this.uri,
    });
}

export default new Footer('/cms/v1/settings/footer');



// WEBPACK FOOTER //
// ./src/libraries/api/footer.tsx